import React, { useState, useEffect } from 'react'
import { getTimeInterval } from '../../utils/commonFunctions'
import { getBiddingHistory } from '../../Services/Bidding.service'
import moment from 'moment-timezone'
import { socket } from '../../../src/Product/common/socket'
import { currencyFormat } from '../../Product/common/components'
import Nodata from '../NoData/nodata'

const BidHistoryList = ({ productId, endTime }) => {
    const [bidHistory, setBidHistory] = useState([])
    const [isloading, setLoading] = useState(false)
    const [bidhistorytime, setBidHistorytime] = useState('')

    useEffect(() => {
        const getHistory = async () => {
            setLoading(true)
            try {
                const response = await getBiddingHistory(productId)
                if (
                    response.data &&
                    response.data.success === 'yes' &&
                    Array.isArray(response.data.results)
                ) {
                    setBidHistory([...response.data.results])
                }
            } catch (err) {
                // handle error
            } finally {
                setLoading(false)
            }
        }
        if (productId) getHistory()
    }, [productId])

    useEffect(() => {
        if (socket) {
            socket.on('sliservertime', (data) => {
                if (moment(data.dTime).isValid()) {
                    const serverTime = new Date(data.dTime)
                    setBidHistorytime(getTimeInterval(endTime || '', serverTime))
                }
            })
        }
    }, [endTime])

    const MaskedText = ({ text }) => {
        if (!text || text.length < 1) return ''
        const maskedText = `${text[0]}${'*'.repeat(text.length - 1)}`
        return (
            <span>
                {text[0]}
                <span className="blur-sm">{maskedText.slice(1)}</span>
            </span>
        )
    }

    if (isloading) return null

    return (
        <>
            {bidHistory.length === 0 ? (
                <Nodata />
            ) : (
                <div className="bidhistoryList">
                    {bidHistory.map((item, index) => (
                        <div key={index} className="py-2 border-b border-b-gray-400">
                            <div className="bidHistTable p-2">
                                <p>Bidder #{index + 1}</p>

                                <p>
                                    {currencyFormat(
                                        parseFloat(item.realproposed_amount).toFixed(2),
                                    )}
                                </p>

                                <p>
                                    {item.created_at
                                        ? moment(item.created_at).format('MMM DD')
                                        : '-'}
                                </p>
                                <p>
                                    {item.created_at
                                        ? moment(item.created_at).format('h:mm A')
                                        : '-'}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}

export default BidHistoryList
